module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vsens5-7426fd77ccc9e58bf7531ddb81f227c5.jpg";